import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../emitter/Observer';
import { ModalResultFinalTeam } from '../../components/common/ModalResultFinalTeam';
import { audiosAssets } from '../../assets/audio';

export const SubtopicFinalTema5 = () => {
	const { loaded } = useSelector(state => state.menu)

	useEffect(() => {
		if (loaded) {
			ObserverEmitter.emit(EVENTS.tema5.subtopicFour.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded])
	return (
		<>
			<ModalResultFinalTeam
				title='¡Felicidades!'
				subTitle='¡Concluiste el Tema 5!'
				buttonText='Iniciar Tema 6'
				actionButton={() => {
					window.location.href = "/home6/tema6/introduction";
				}} actionBack={() => {
					window.location.href = "/home1";
				}}

			/>
		</>
	)
}